import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const DUMP_THE_COMBO_ACTIVITY_FRAGMENT = gql `
  fragment DumpTheComboActivityFragment on DumpTheComboActivity {
    targetKey
    rounds {
      id
      letterCombo
      wordPart
      steps {
        id
        answer
        answerAudio {
          id
          audio {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default DUMP_THE_COMBO_ACTIVITY_FRAGMENT;
